import { coreDefaultTheme } from '@kite-js/theme';
import { corePricelineTheme } from './theme-priceline';
import { ULTheme, ULThemeBuilder } from '@theme/types';

const PricelineThemeBuilder: ULThemeBuilder = (cultureCode?: string, appId?: string) => {
    const theme: ULTheme = {
        ...coreDefaultTheme,
        ...corePricelineTheme,
        logoUrl: 'https://cdn6.agoda.net/images/MVC/default/pcln-logo-blue@2x.png',
        background: {
            image:
                'url(https://cdn6.agoda.net/images/MVC/default/background_image/illustrations/background-flight-priceline.png)',
            position: '0 0',
            size: '100% 100%',
        },
        faviconUrl: 'https://cdn6.agoda.net/images/MVC/default/favicon/priceline/favicon.ico',
        input: {
            ...coreDefaultTheme.input,
            borderRadius: 'S',
        },
        tab: {
            ...coreDefaultTheme.tab,
            padding: '12px 8px 12px 8px',
        },
    };

    return theme;
};

export default PricelineThemeBuilder;
